// extracted by mini-css-extract-plugin
export default {"modal":"Cea-z","modalContent":"Dea-z","footer":"Eea-z","cancelBtn":"Fea-z","disabled":"Gea-z","formWrapper":"Hea-z","fade":"Iea-z","fade-in":"Jea-z","iframe":"Kea-z"};